import { COLORS } from '@btime/constants'
import React from 'react'

import Center from '../../../../../packages/kiti/components/helpers/Center'
import Icon from '../../../../../packages/kiti/components/shapes/Icon'
import Text from '../../../../../packages/kiti/components/presentation/Text'
import Tooltip from '../../../../../components/helpers/Tooltip'

const InfoTag = ({ condition, icon, label, color }) => {
  if (!condition) return false

  return (
    <Tooltip
      actionContent={
        <Center>
          <Icon name={icon} color={color} size={0.8} />
        </Center>
      }
    >
      <Text>{label}</Text>
    </Tooltip>
  )
}

const FieldInfoTags = ({ field }) => {
  const { private: privateField, defaultValue, required } = field

  return (
    <>
      <InfoTag
        condition={![undefined, null].includes(defaultValue)}
        label="Valor inicial pré definido"
        icon="BsLayersHalf"
        color="dark4"
      />
      <InfoTag condition={privateField} label="Confidencial" icon="BsEyeSlash" color="dark4" />
      <InfoTag condition={required} label="Obrigatória" icon="BsExclamationCircle" color={COLORS.red} />
    </>
  )
}

export default FieldInfoTags
